import { ScriptCardResponse } from '@/models/scripts'
import { CardVariant } from '@/constants/scripts'

export interface ScriptEditState {
  cardId?: string
  scriptId?: string
  instanceId?: string
  cards: Record<string, ScriptCardResponse>
  variant: CardVariant
}

export const initialState: ScriptEditState = {
  cardId: undefined,
  scriptId: undefined,
  instanceId: undefined,
  cards: {},
  variant: CardVariant.A,
}
